import { UTCDate } from '@date-fns/utc';
import { isWithinInterval } from 'date-fns';
import { TransactionView } from '../../../types/entity-types';

type GetTransactionsInTimeframeArgs = {
  transactions: TransactionView[];
  startDate: Date;
  endDate: Date;
};

export const getTransactionsInTimeframe = ({ transactions, startDate, endDate }: GetTransactionsInTimeframeArgs) => {
  return transactions.filter((t) => isWithinInterval(new UTCDate(t.fspDate), { start: startDate, end: endDate }));
};
